export default function Footer() {
  return (
    <footer className="bg-[#050505] border-t border-white/10 pt-24 pb-12" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-4 gap-12 mb-20">
          <div className="md:col-span-2">
            <span className="font-serif-display text-3xl text-white">
              Sol<span className="text-gold">Club</span>
            </span>
            <p className="text-white/50 font-light mt-6 max-w-sm leading-relaxed">
              Un concierge de viajes privado para quienes su tiempo es su activo más valioso.
              Acceso, discreción y orquestación impecable — en todo el mundo.
            </p>
          </div>
          <div>
            <h4 className="text-xs tracking-luxe uppercase text-gold mb-6">Servicios</h4>
            <ul className="space-y-3 text-white/60 font-light text-sm">
              <li>Hoteles & Villas de Lujo</li>
              <li>Viajes Corporativos</li>
              <li>Experiencias VIP</li>
              <li>Aviación & Yates</li>
            </ul>
          </div>
          <div>
            <h4 className="text-xs tracking-luxe uppercase text-gold mb-6">Contacto</h4>
            <ul className="space-y-3 text-white/60 font-light text-sm">
              <li>Socios: concierge@solclub.es</li>
              <li>General: contacto@solclub.es</li>
            </ul>
          </div>
        </div>
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 pt-8 border-t border-white/10">
          <p className="text-white/30 text-xs tracking-luxe-sm">© 2026 SOLCLUB.ES — TODOS LOS DERECHOS RESERVADOS</p>
          <p className="text-white/30 text-xs tracking-luxe-sm">SolClub® — Luxury Travel Concierge</p>
        </div>
      </div>
    </footer>
  );
}
